<div class="auth-main-content auth-main-content-only">
  <div class="left-block">
    <div class="overlay-content">
      <div class="logo-block">
        <img
          src="./assets/images/new-logo-cropped.svg"
          class="main-logo"
          alt="TaskOPad Logo"
          draggable="false"
        />
      </div>
      <div class="inner-form-block h-100">
        <div class="mt-md-auto mb-md-auto mt-sm-0 mt-0 mb-md-0 mb-0">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="footer-line">
        <p>
          {{ "SUPPORT" | translate }} | {{ "RESOURCE" | translate }} |
          {{ "GUIDE" | translate }} | {{ "PRICING" | translate }} |
          {{ "TERMS" | translate }} | {{ "PRIVACY" | translate }} |
          {{ buildVersion }}
        </p>
      </div>
    </div>
  </div>
  <div
    class="right-block d-flex align-content-center justify-content-center flex-wrap"
  >
    <div class="dt-block">
      <div class="circle">
        <img
          src="./assets/images/new_logo.svg"
          class=""
          alt="TaskOPad Logo"
          draggable="false"
        />
      </div>
      <owl-carousel-o [options]="customOptions" class="w-100">
        <ng-template carouselSlide>
          <div class="slide-class">
            <h2>
              Empower Your Productivity: Log In to TaskOPad and Get Things Done
            </h2>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="slide-class">
            <h2>
              "Welcome to TaskOPad: The Ultimate Task Management Solution. Plan,
              Prioritize, and Propel Your Success."
            </h2>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="slide-class" style="color: white">
            <h6>
              ASSIGN: Input your task and seleCt the team member you want to
              assign it to.
            </h6>
            <h6>
              TRACK: Track daily, weekly progress of the tasks and its
              dependencies.
            </h6>
            <h6>
              ACHIEVE: Send and recieve docs and files for approval and mark
              them as done.
            </h6>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</div>
